import {
  Settings as SettingsIcon,
  Shield,
  CheckCircle,
  LogOut
} from 'lucide-react';
import { useAuthStore } from '@/store/auth';

export default function SettingsPage() {
  const logout = useAuthStore((state) => state.logout);

  return (
    <div className="p-6 lg:p-8 max-w-3xl">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">设置</h1>
        <p className="text-gray-500 mt-1">管理您的应用设置</p>
      </div>

      <div className="card p-6 mb-6">
        <div className="flex items-center gap-3 mb-4">
          <Shield className="w-5 h-5 text-primary-600" />
          <h2 className="text-lg font-semibold text-gray-900">安全</h2>
        </div>

        <div className="p-4 bg-gray-50 rounded-lg">
          <div className="flex items-start gap-3">
            <CheckCircle className="w-5 h-5 text-green-600 mt-0.5" />
            <div>
              <p className="font-medium text-gray-900">配置安全</p>
              <p className="text-sm text-gray-500 mt-1">
                Notion Token 和 Page ID 配置在服务器环境变量中，不会暴露给前端。
                所有 API 请求需要通过密码验证。
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="card p-6 mb-6">
        <div className="flex items-center gap-3 mb-4">
          <SettingsIcon className="w-5 h-5 text-primary-600" />
          <h2 className="text-lg font-semibold text-gray-900">关于</h2>
        </div>

        <div className="space-y-3 text-sm text-gray-600">
          <p>Notion 文件管理器 v1.0</p>
          <p>基于 Cloudflare Workers + Pages 构建</p>
          <p>使用 React + TypeScript + Tailwind CSS</p>
        </div>
      </div>

      <div className="pt-6 border-t border-gray-200">
        <button
          onClick={logout}
          className="btn btn-ghost flex items-center gap-2 text-gray-500 hover:text-gray-700"
        >
          <LogOut className="w-4 h-4" />
          退出登录
        </button>
      </div>
    </div>
  );
}